module.exports = __webpack_public_path__ + "static/media/terms-of-use.9d84daf7.pdf";